// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__JHshz","copyright":"Footer_copyright__Fa7fx"};